import {ClassComponent, Vnode} from 'mithril';
import {FieldValidationErrors} from '../models/JsonTypes';

interface ValidationErrorsAttrs {
    errors: string[] | FieldValidationErrors
}

export default class ValidationErrors implements ClassComponent<ValidationErrorsAttrs> {
    view(vnode: Vnode<ValidationErrorsAttrs, this>) {
        let errors = vnode.attrs.errors || [];

        // This check is to make using FormGroup outside of templates easier,
        // as we can simply pass the validation tree filtered to the key, and take care of the "errors" sub-object here
        if (typeof errors === 'object' && !Array.isArray(errors)) {
            errors = errors.errors || [];
        }

        return errors && errors.length ? m('ul.FormulaireValidationErrors', errors.map(error => m('li', error))) : m('div') /* empty element because null doesn't work */;
    }
}
